import { todayDate } from "../../common/DateFormatters";
const DonationExist = ({ setRequestStep, barCode, translationMap }) => {
  return (
    <>
        <section
        className="w-100 clearfix BloodDonationMainSection"
        id="CoverPlanActive">
        
          <div className="container customContainer">
            <div className="cover_inner_wrapper">
              <div className="cover_main_box1">
                <div className="qr_code_questionnaire_wrap">
                  <div className="bd_summary_box">
                    <div className="bd_summary_text_box">
                      <p className="date_text" style={{ direction: "ltr" }}>{todayDate()}</p>
                      <p className="Gray_Title bottom_text bottom_text_italic">
                        {translationMap?.codeValidToday}
                      </p>
                    </div>
                    <div className="bd_summary_icon_box">
                      {/* <img src="images/blood_donation_questionire_QR.png" alt="" /> */}
                      <img
                      src={`data:image/png;base64,${barCode}`}
                      alt="Displaying barcode" />
                    
                    </div>
                  </div>
                  <div className="questionire_btn_box">
                    <span>
                      <button
                      onClick={() => {
                        //setAlreadyExist(false);
                        setRequestStep(-1);
                        window.parent.scrollTo(0, 0);
                      }}
                      className="bluetrans_btn_link">
                      
                        {translationMap?.backToDammi}
                      </button>
                    </span>
                    <span>
                      <button
                      onClick={() => {setRequestStep(2);
                        window.parent.scrollTo(0, 0);
                      }}
                      className="bluetrans_btn_link">
                      
                        {translationMap?.createNewRequest}
                      </button>
                    </span>
                  </div>
                </div>
              </div>
              <div className="cover_main_box2"></div>
            </div>
          </div>
        </section>
    </>);

};

export default DonationExist;